import Component from './Duplicate.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionDuplicate', Component);
  },
};
